export const getLocale = () => {
  const locale = navigator.language || 'en';

  return locale;
};

export const isUs = () => {
  return getLocale().startsWith('en-US');
};
